module.exports = __webpack_public_path__ + "static/20250328_HSE_Transaction_Announcement-07856feba1c7ebf20fc597953086953f.pdf";